import axios from 'axios'
import { toSnakeCase, toCamelCase } from './data-format'
import { getToken,removeToken,removeAll } from '@/utils/auth'
import { Message } from 'element-ui';
import store from '@/store'
import getBaseURL from '@/utils/setBaseURL'
const http = axios.create({
  timeout: 30000
})

http.interceptors.request.use(
  config => {
    const token = getToken(store.getters.authorityRoute)
    config.headers.common['Authorization'] = `Bearer ${token}`
    config.headers.common['accept-language'] = `en`
    if (!config.unformat) {
      config.params = toSnakeCase(config.params)
      config.data = toSnakeCase(config.data)
    }
    // console.log(baseURL())
    // config.baseURL = '/api'
    config.baseURL = getBaseURL()
    // config.baseURL = process.env.VUE_APP_BUILD_API + `${store.getters.authorityRoute}/api/v1`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    if (response.headers['content-type'] === 'application/json') {
      response.data = toCamelCase(response.data)
    }
    return response
  },
  error => {
    if (error.response.status === 401) {
      removeToken(store.getters.authorityRoute);
      removeAll();
      location.reload();
    } else if (error.response.status === 500) {      
      Message.error(error.response.data.message);
    } else {
      Message.error(error.response.data.error_message);
    }
    return Promise.reject(error)
  }
)

export default http
